const mineRoute = [
  {
    path: "view",
    name: "mineView",
    component: resolve => require(['@/views/aboutMe/view'], resolve),
    meta: {
      title: "$t-mineView",
      controlField: "myMenu",
    },
  },
  {
    path: "/about/plugin",
    name: "plugin",
    meta: { controlField: "myMenu" },
    component: resolve => require(['@/views/aboutMe/pluginMall'], resolve),
  },
  {
    path: "/about/pluginMall",
    name: "pluginMall",
    meta: { controlField: "myMenu" },
    component: resolve => require(['@/views/aboutMe/pluginMall/pluginMall'], resolve),
  },
  {
    path: "/about/myPlugin/:reload?",
    name: "myPlugin",
    meta: { controlField: "myMenu" },
    component: resolve => require(['@/views/aboutMe/pluginMall/myPlugin'], resolve),
  },
  {
    path: "/about/pluginDetail/:appId",
    name: "pluginDetail",
    props: true,
    meta: { controlField: "myMenu" },
    component: resolve => require(['@/views/aboutMe/pluginMall/pluginDetail'], resolve),
  },
  {
    path: "browserPlug",
    name: "browserPlug",
    meta: {
      title: "$t-browserPlug",
      controlField: "myMenu",
    },
    component: resolve => require(['@/views/aboutMe/browserPlug'], resolve),
  },
  {
    path: "myReportView/:reportId?",
    name: "myReportView",
    meta: { controlField: "myMenu" },
    component: resolve => require(['@/views/report/reportView'], resolve),
  },
  {
    path: "collectView/:reportId?",
    name: "collectView",
    meta: { controlField: "myMenu" },
    component: resolve => require(['@/views/report/reportView'], resolve),
  },
  {
    path: "/about/collect",
    name: "mineCollect",
    component: resolve => require(['@/views/aboutMe/collect'], resolve),
    meta: {
      title: "$t-mineCollect",
      controlField: "myMenu",
    },
  },
  // RoleChange
  {
    path: "RoleChange",
    name: "RoleChange", //海康特有路由
    component: resolve => require(['@/views/login/checkLicense'], resolve),
    meta: {
      title: "$t-switchRole",
      controlField: "myMenu",
    },
  },
  {
    path: "/about/message",
    name: "mineMessage",
    meta: { controlField: "messageCenter" },
    redirect: "/about/message/announcement",
    component: resolve => require(['@/views/aboutMe/message/message'], resolve),
    children: [
      {
        path: "announcement",
        name: "announcement",
        meta: { controlField: "messageCenter", nextMenu: 'systemmsg' },
        component: resolve => require(['@/views/aboutMe/message/children/announcement'], resolve),
      },
      {
        path: "systemmsg",
        name: "systemmsg",
        meta: { controlField: "messageCenter", nextMenu: 'mymsg' },
        component: resolve => require(['@/views/aboutMe/message/children/systemmsg'], resolve),
      },
      {
        path: "mymsg",
        name: "mymsg",
        meta: { controlField: "messageCenter", nextMenu: '404' },
        component: resolve => require(['@/views/aboutMe/message/children/mymsg'], resolve),
      },
    ],
  },
  {
    path: "/about/comment",
    name: "mineComment",
    meta: { controlField: "relatedDiscussion" },
    component: resolve => require(['@/views/aboutMe/comment/commentView'], resolve),
    redirect: "/about/comment/fromMe",
    children: [
      {
        path: "fromMe",
        name: "fromme",
        meta: { controlField: "relatedDiscussion" },
        component: resolve => require(['@/views/aboutMe/comment/comment'], resolve),
      },
      {
        path: "toMe",
        name: "tome",
        meta: { controlField: "relatedDiscussion" },
        component: resolve => require(['@/views/aboutMe/comment/comment'], resolve),
      },
      {
        path: "callMe",
        name: "callme",
        meta: { controlField: "relatedDiscussion" },
        component: resolve => require(['@/views/aboutMe/comment/comment'], resolve),
      },
    ],
  },
  {
    path: "/about/task",
    name: "mineTask",
    meta: { controlField: "myTask" },
    component: resolve => require(['@/views/aboutMe/mineTask'], resolve),
    redirect: "/about/task/todo",
    children: [
      {
        path: "todo",
        name: "tasktodo",
        meta: { controlField: "myTask" },
        component: resolve => require(['@/views/aboutMe/mineTask/taskTodo'], resolve),
      },
      {
        path: "done",
        name: "taskdone",
        meta: { controlField: "myTask" },
        component: resolve => require(['@/views/aboutMe/mineTask/taskDone'], resolve),
      },
      {
        path: "initProcess",
        name: "initprocess",
        meta: { controlField: "myTask" },
        component: resolve => require(['@/views/aboutMe/mineTask/initProcess'], resolve)
      },
      {
        path: "myFile",
        name: "myfile",
        meta: { controlField: "myTask" },
        component: resolve => require(['@/views/aboutMe/mineTask/myFile'], resolve)
      },
      {
        path: "dataManagement",
        name: "datamanagement",
        meta: { controlField: "myTask" },
        component: resolve => require(['@/views/aboutMe/mineTask/dataManagement/index'], resolve)
      },
    ],
  },
  {
    path: "/about/task/dataManagement/:templateId",
    name: "dataMaintain",
    component: resolve => require(['@/views/aboutMe/mineTask/dataManagement/maintain'], resolve),
    meta: {
      activeTab: "datamanagement",
      controlField: "myTask",
    },
  },
  {
    path: "/about/task/checkProcess/:taskId/:taskName/:curPage",
    name: "checkProcess",
    component: resolve => require(['@/views/aboutMe/mineTask/child/checkProcess'], resolve),
    meta: {
      activeTab: "tasktodo",
      controlField: "myMenu",
    },
  },
  {
    path: "/about/task/checkData/:taskId/:jobID/:taskName/:curPage",
    name: "checkData",
    component: resolve => require(['@/views/aboutMe/mineTask/child/checkData'], resolve),
    meta: {
      activeTab: "tasktodo",
      controlField: "myMenu",
    },
  },
  {
    path: "/about/task/checkForm/:taskId/:jobID/:taskName/:curPage",
    name: "checkForm",
    component: resolve => require(['@/views/aboutMe/mineTask/child/checkForm'], resolve),
    meta: {
      activeTab: "tasktodo",
      controlField: "myMenu",
    },
  },
  {
    path: "/about/callmine",
    name: "callMine",
    component: resolve => require(['@/views/aboutMe/callmine'], resolve),
    meta: {
      title: "$t-mine",
      controlField: "myMenu",
    },
  },
  {
    path: "/about/bonusmall",
    name: "bonusMall",
    component: resolve => require(['@/views/aboutMe/bonusMall'], resolve),
    meta: {
      title: "$t-comingsoon",
      controlField: "myMenu",
    },
  },
  // {
  //   path: "/about/taskPush",
  //   name: "taskPush",
  //   redirect: '/about/taskPush/KPIPush',
  //   component: resolve => require(['@/views/aboutMe/taskPush'],resolve),
  //   meta: {
  //     title: "$t-taskPush"
  //   },
  //   children: [
  {
    path: "KPIPush",
    name: "KPIPush",
    meta: { controlField: "pushTask", nextMenu: 'ImgPush' },
    component: resolve => require(['@/views/aboutMe/taskPush/KPIPush'], resolve),
  },
  {
    path: "createKPIPush",
    name: "createKPIPush",
    meta: {
      title: "$t-新建kpi推送",
      controlField: "pushTask",
    },
    component: resolve => require(['@/views/aboutMe/taskPush/createKpiPush'], resolve),
  },
  {
    path: "createImgPush",
    name: "createImgPush",
    meta: {
      title: "$t-新建img推送",
      controlField: "pushTask",
    },
    component: resolve => require(['@/views/aboutMe/taskPush/createImgPush'], resolve),
  },

  {
    path: "editKPIPush/:id",
    name: "editKPIPush",
    meta: {
      title: "$t-新建kpi推送",
      controlField: "pushTask",
    },
    component: resolve => require(['@/views/aboutMe/taskPush/createKpiPush'], resolve),
  },
  {
    path: "editimgPush/:id",
    name: "editimgPush",
    meta: {
      title: "$t-新建kpi推送",
      controlField: "pushTask",
    },
    component: resolve => require(['@/views/aboutMe/taskPush/createImgPush'], resolve),
  },
  {
    path: "ImgPush",
    name: "ImgPush",
    meta: { nextMenu: 'EbiReportPush', controlField: "pushTask", },
    component: resolve => require(['@/views/aboutMe/taskPush/ImgPush'], resolve),
  },
  {
    path: "EbiReportPush",
    name: "EbiReportPush",
    meta: { controlField: "pushTask", nextMenu: '404' },
    component: resolve => require(['@/views/aboutMe/taskPush/EbiReportPush'], resolve),
  },
  {
    path: "/about/cardDesign",
    name: "cardDesignView",
    meta: { controlField: "myMenu" },
    component: resolve => require(['@/views/aboutMe/cardDesign/cardDesign'], resolve),
  },
  {
    path: "/about/myInfo",
    name: "myInfo",
    // redirect: "/",//奥乐齐的我的信息页面重定向到首页
    component: resolve => require(['@/views/aboutMe/myInfo'], resolve),
    meta: {
      title: "$t-personalData",
      controlField: "myMenu",
    },
  },
  {
    path: "/about/mySetting",
    name: "mySetting",
    redirect: "/about/mySetting/PreferSetting",
    component: resolve => require(['@/views/aboutMe/mySetting'], resolve),
    meta: { controlField: "myMenu" },
    children: [
      {
        path: "PreferSetting",
        name: "PreferSetting",
        meta: { controlField: "myMenu" },
        component: resolve => require(['@/views/aboutMe/mySetting/preferSetting'], resolve),
      },
      {
        path: "PermisSetting",
        name: "PermisSetting",
        meta: { controlField: "myMenu" },
        component: resolve => require(['@/views/aboutMe/mySetting/permisSetting'], resolve),
      },
    ],
  },
];
export default mineRoute;
